
    .facelift3513331464__root .BadgeIndicator3494530999__root {
        --BadgeIndicator3494530999-color-standard: #116dff;
        --BadgeIndicator3494530999-color-alert: #e62214;
        --BadgeIndicator3494530999-color-warning: #ffb700;
        --BadgeIndicator3494530999-color-success: #25a55a;
    }

/* st-namespace-reference="../../../../src/skins/facelift/BadgeIndicator.st.css" */